import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class WPEngineCompleted extends React.Component {
	routeTo(url) {
		window.open(url, '_blank', 'noopener,noreferrer')
	}	
	render() {
		const { migrate } = this.props
		return <div className="wpe d-flex">
			<div className="migration-results">
				<img width="300" height="300" src="/assets/wpengine/migration-success.svg" alt="migration-success-logo"/>
				<h1 className="align-center">Migration completed successfully!</h1>
				{ migrate.get('is_site_woocommerce') ? <div className="migration-results-panel migration-results-info">
					<img src="/assets/wpengine/information-icon.svg" alt="information icon"/>
					<p>To avoid losing orders on your WooCommerce site,
						{' '}we strongly recommend that you re-run this migration plugin just before you go live on WP Engine.
						<a href="https://wpengine.com/support/wp-engine-automatic-migration-powered-by-blogvault/" target="_blank" rel="noreferrer">
							{' '}Learn more about the migration process
						</a>
					</p>
				</div> : null }
				<div className="migration-results-text">
					<p>Source: <a href={migrate.get('source_site')} target="_blank" rel="noopener noreferrer">{migrate.get('source_site')}</a></p>
					<p>Destination: <a href={migrate.get('destination_site')} target="_blank" rel="noopener noreferrer">{migrate.get('destination_site')}</a></p>
				</div>
				<button className="button migrate-button width33" onClick={() => this.routeTo(migrate.get('destination_site'))}>
					Go to migrated site
				</button>
				<button className="button cancel-button" onClick={() => this.routeTo('http://my.wpengine.com/')}>
					Go to my.wpengine.com
				</button>
			</div>
		</div>
	}
}

WPEngineCompleted.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default WPEngineCompleted
